module.exports = __webpack_public_path__ + "img/thanks1.670a194f.svg";